<script setup lang="ts">
import type { IProps } from '@/features/SuccessBlock/model/types/successBlock';

defineProps<IProps>();

const isMobile: boolean = useIsMobile();
</script>

<template>
  <div
    class="success"
    data-testid="success-block"
    :class="[{ _mobile: isMobile }, { _horizontal: isHorizontalForm }]"
  >
    <div class="success__header">
      <AppIcon name="Check" class="success__icon" />
      <span class="success__title" data-testid="success-title">Запрос отправлен!</span>
    </div>
    <div class="success__text" data-testid="success-text">
      Скоро с вами свяжется наш специалист
    </div>
  </div>
</template>

<style lang="less">
.success {
  display: flex;
  flex-direction: column;
  align-items: center;

  &__header {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__title {
    font-weight: 600;
    font-size: @size-x6;
    line-height: 25px;
    margin: @size-x2 0 @size-x8;
  }

  &__text {
    text-align: center;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
  }

  &__icon {
    display: inline-flex;

    path {
      stroke: @color-persimmon;
    }
  }

  &._horizontal {
    display: block;
  }

  &._horizontal &__header {
    flex-direction: row;
    margin-bottom: @size-x5;
  }

  &._horizontal &__title {
    color: #fff;
    margin: 0;
  }

  &._horizontal &__text {
    text-align: left;
    color: #fff;
    margin-left: 31px;
  }

  &._horizontal &__icon {
    margin-right: 7px;
    width: 25px;
    height: 24px;
  }

  &._mobile._horizontal &__title {
    font-size: @size-x6;
    line-height: 25px;
    margin: 0;
  }

  &._mobile._horizontal &__text {
    font-size: 14px;
    line-height: 21px;
    margin-left: 29px;
    max-width: 178px;
    margin-top: 0;

    @media screen and (max-width: @max-width-m) {
      margin-left: 29px;
    }
  }

  &._mobile._horizontal &__icon {
    width: @size-x6;
    height: @size-x6;
    margin-right: 5px;
  }

  &._mobile &__header {
    flex-direction: row;
  }

  &._mobile &__title {
    font-size: @size-x4;
    line-height: @size-x4;
    margin: 0 0 0 6px;
  }

  &._mobile &__text {
    font-size: @size-x3;
    line-height: 18px;
    text-align: left;
    max-width: 217px;
    margin-left: 62px;
    margin-top: 14px;

    @media screen and (max-width: @max-width-m) {
      margin-left: 102px;
    }
  }

  &._mobile &__icon {
    width: 60px;
    height: 60px;
  }
}
</style>
